module.exports = __webpack_public_path__ + "static/ask-about-social-171d22dd1d858aadd1f6f476d49cd454.jpg";